import mapboxgl from "mapbox-gl";

export enum IconType {
    HERMES_ARROW = "triangle_dark_orange",
    HERMES_WAIT_ARROW = "triangle_dark_pink",
    THIN_ARROW = "arrows",
    CAR = "car_smile",
    TRIANGLE_ORANGE = "triangle_orange",
    TRIANGLE_RED = "triangle_red",
    SQUARE_ORANGE = "square_orange",
    SQUARE_RED = "square_red",
    SQUARE_BLACK = "square_black",
}

export const getIconPath = (iconType: IconType): string => {
    switch (iconType) {
        case IconType.CAR:
            return "/image/Car/taxi-icon.png";
        case IconType.THIN_ARROW:
            return "/image/Arrows/triangle-small-black.png";
        case IconType.HERMES_ARROW:
            return "/image/Arrows/triangle-small-green.png";
        case IconType.HERMES_WAIT_ARROW:
            return "/image/Arrows/triangle-small-pink.png";
        case IconType.SQUARE_ORANGE:
            return "/image/Squares/square-orng.png";
        case IconType.SQUARE_RED:
            return "/image/Squares/square-red.png";
        case IconType.SQUARE_BLACK:
            return "/image/Squares/square-blk.png";
        case IconType.TRIANGLE_ORANGE:
            return "/image/Triangles/triangle-orng.png";
        case IconType.TRIANGLE_RED:
            return "/image/Triangles/triangle-red.png";
    }
};

// mapbox.Mapの内部で読み込んでおり、GETで読んでいるがキャッシュの設定がされていないので常時APIにリクエストが行き、都度304が返されている。
// アクセス自体を減らすため、アイコンイメージをキャッシュさせる。
// map.loadImageで返されるimageの形式が不明なので、読み込みはmapboxに任せ、結果を内部でキャッシュする
// ASK ログアウト時もキャッシュがクリアされないがこれでいいか？　ダメなら消す方法を決めたい
const iconCache = new Map<String, any>();
export const loadIcons = (map: mapboxgl.Map): void => {
    for (const x in IconType) {
        const image = iconCache.get(x);
        if (image !== undefined) {
            map.addImage(IconType[x], image);
            continue;
        }
        const name = IconType[x];
        const path = getIconPath(name);
        map.loadImage(path, (err, image) => {
            if (err) {
                console.log(err, name, path);
                return;
            }
            map.addImage(IconType[x], image);
            iconCache.set(x, image);
        });
    }
};
